/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ch_When_DInputs */

const en_cp_ch_when_d = /** @type {(inputs: Cp_Ch_When_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entries open in week 12, close at demo day (week 14), results at the start of the next semester — right before P2MW/PKM proposal season. Edition #1: January 2027.`)
};

const id_cp_ch_when_d = /** @type {(inputs: Cp_Ch_When_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entri dibuka minggu 12, ditutup di demo day (minggu 14), pengumuman awal semester berikutnya — tepat sebelum musim proposal P2MW/PKM. Edisi #1: Januari 2027.`)
};

/**
* | output |
* | --- |
* | "Entries open in week 12, close at demo day (week 14), results at the start of the next semester — right before P2MW/PKM proposal season. Edition #1: January ..." |
*
* @param {Cp_Ch_When_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ch_when_d = /** @type {((inputs?: Cp_Ch_When_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ch_When_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ch_when_d(inputs)
	return en_cp_ch_when_d(inputs)
});